import { render, staticRenderFns } from "./similarProductsCart.vue?vue&type=template&id=76835350"
import script from "./similarProductsCart.vue?vue&type=script&lang=js"
export * from "./similarProductsCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports